function addActiveClass(button) {
  const product_id = button.dataset.productId;
  const variant_id = button.dataset.variantId;

  const images = document.querySelectorAll(`.variant-image[data-product-id="${product_id}"]`);
  images.forEach((img) => {
    img.classList.remove('active');
  });

  if (button.classList.contains('active')) {
    button.classList.remove('active');
  } else {
    const buttons = document.querySelectorAll(`.card__colors__button[data-product-id="${product_id}"]`);
    buttons.forEach((btn) => {
      btn.classList.remove('active');
    });

    button.classList.add('active');

    const targetImage = document.querySelector(`.variant-image[data-variant-id="${variant_id}"]`);
    if (targetImage) {
      targetImage.classList.add('active');
    }
  }
}

const sortOptionLabel = document.querySelector('.facet-filters__label');
if (sortOptionLabel) {
  sortOptionLabel.addEventListener('click', function () {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
      const siblings = this.nextElementSibling;
      console.log(siblings);
      if (siblings.classList.contains('buttons')) {
        siblings.classList.remove('active');
      }
    } else {
      this.classList.add('active');
      const siblings = this.nextElementSibling;
      if (siblings.classList.contains('buttons')) {
        siblings.classList.add('active');
      }
    }
  });
}
